<template>
  <div>
    <div class="notify-actions-row">
      <button
        :class="notifyClasses"
        @click="
          !$auth.loggedIn ? $auth.openAuthModal() : (notifyMeModalOpen = true)
        "
      >
        <span class="icon-bell"></span>
        <span>{{ notificationChecked ? 'Saved' : 'Notify Me' }}</span>
      </button>
      <HeartIcon :product="product" />
    </div>
    <NotifyMeModal
      :visible="notifyMeModalOpen"
      :product-id="product.product_id"
      @closed="notifyMeModalOpen = false"
    />
  </div>
</template>

<script>
import { requestedNotification } from '#common/utils/catalog'

export default {
  components: {
    NotifyMeModal: defineAsyncComponent(
      () => import('#common/components/NotifyMe/NotifyMeModal'),
    ),
    HeartIcon: defineAsyncComponent(
      () => import('@/components/UserList/HeartIcon.vue'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notifyMeModalOpen: false,
    }
  },
  computed: {
    notificationChecked() {
      return requestedNotification(this.$auth.user, this.product.product_id)
    },
    notifyClasses() {
      return {
        'notify-me': true,
        checked: this.notificationChecked,
      }
    },
  },
}
</script>
